/* eslint no-param-reassign: 0 */

const sidebarState = {
  sidebarCollapsed: false,
  darkmode: null,
  lastRoute: null,
  liveshoppingMessageSeen: false,
  ppvDiscontinuedSeen: false,
  ppvMessageSeen: false,
  onboardingDone: false,
  shoplineMode: false,
};

const mutations = {
  sidebarCollapse(state, bool) {
    state.sidebarCollapsed = bool;
  },
  shoplineMode(state) {
    state.shoplineMode = true;
  },
  toggleDarkmode(state, bool) {
    state.darkmode = bool;
  },
  lastRoute(state, path) {
    state.lastRoute = path;
  },
  toggleLiveshoppingMessageSeen(state) {
    state.liveshoppingMessageSeen = true;
  },
  togglePpvDiscontinuedSeen(state) {
    state.ppvDiscontinuedSeen = true;
  },
  togglePPVMessageSeen(state) {
    state.ppvMessageSeen = true;
  },
  toggleOnboardingDone(state) {
    state.onboardingDone = true;
  },
};

const getters = {
  sidebarCollapsed: state => state.sidebarCollapsed,
  darkmode: state => state.darkmode,
  lastRoute: state => state.lastRoute,
  liveshoppingMessageSeen: state => state.liveshoppingMessageSeen,
  ppvDiscontinuedSeen: state => state.ppvDiscontinuedSeen,
  ppvMessageSeen: state => state.ppvMessageSeen,
  onboardingDone: state => state.onboardingDone,
  shoplineMode: state => state.shoplineMode,
};

const actions = {
  sidebarCollapse({ commit }, bool) {
    commit('sidebarCollapse', bool);
  },
  toggleDarkmode({ commit }, bool) {
    commit('toggleDarkmode', bool);
  },
  lastRoute({ commit }, path) {
    commit('lastRoute', path);
  },
  liveshoppingMessageSeen({ commit }) {
    commit('toggleLiveshoppingMessageSeen');
  },
  ppvDiscontinuedSeen({ commit }) {
    commit('togglePpvDiscontinuedSeen');
  },
  onboardingDone({ commit }) {
    commit('toggleOnboardingDone');
  },
  ppvMessageSeen({ commit }) {
    commit('togglePPVMessageSeen');
  },
};

export default {
  namespaced: true,
  state: sidebarState,
  mutations,
  getters,
  actions,
};
